export default "__VITE_ASSET__0b74dd67__"